/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type CloseUseCreditActionActionType =
  (typeof CloseUseCreditActionActionType)[keyof typeof CloseUseCreditActionActionType];

export const CloseUseCreditActionActionType = {
  close_use_credits: 'close_use_credits',
} as const;
